export default __webpack_public_path__ + "static/SegoeUI-Mono-Regular-18000c884117844cab2d27594366c79e.ttf";